import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import FsLightbox from "fslightbox-react";
import { useTranslation } from 'react-i18next';

import WavesShader from './WavesShader';

const HeroTwo = () => {
    const [toggler, setToggler] = useState(false);
    const { t } = useTranslation();

    return (
    <>
        <div className="ot-hero-wrapper hero-2" id="hero2">
            <div className="waves-wrapper">
                <WavesShader />
            </div>
            <div className="hero-bg-line1">
                <div className="line" />
                <div className="line" />
                <div className="line" />
                <div className="line" />
                <div className="line" />
                <div className="line d-sm-block d-none" />
                <div className="line d-sm-block d-none" />
                <div className="line d-sm-block d-none" />
                <div className="line d-sm-block d-none" />
                <div className="line d-sm-block d-none" />
            </div>
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-12">
                        <div className="hero-style2">
                            <h1 className="hero-title">
                                <span className="title1" data-cue="slideInUp" data-delay={100}>
                                {t('sections.heroTwo.title_part1','Securing Your Digital World,')}
                                </span>
                                <span className="title2" data-cue="slideInUp" data-delay={200}>
                                {t('sections.heroTwo.title_part2','One Click at a Time')}
                                </span>
                            </h1>
                            <p className="hero-text" data-cue="slideInUp" data-delay={300}>
                                {t('sections.heroTwo.text','Since 1999, Secur has safeguarded digital landscapes. Our cloud security solutions protect your data and applications from threats. Fortify your future with Secur.')}
                            </p>
                            <div className="btn-wrap justify-content-center" data-cue="slideInUp" data-delay={200}>
                                <Link to="/contact" className="ot-btn">
                                {t('sections.heroTwo.contact','Contact Us')} <i className="far fa-long-arrow-right ms-2" />
                                </Link>
                    
                                <a href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setToggler(!toggler);
                                    }}
                                    className="video-btn-wrap"
                                >
                                    <span className="play-btn">
                                        <i className="fas fa-play" />
                                    </span>
                                    {t('sections.heroTwo.watch_video','Watch Video')}
                                </a>

                                <FsLightbox
                                    toggler={toggler}
                                    sources={[
                                        "https://www.youtube.com/watch?v=Z4F3AXvrLKo"
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>

  );
};

export default HeroTwo;